import Vue from 'vue';
import Vuex from 'vuex';
import utils from '@/utils';

Vue.use(Vuex);

const defaultState = {
  projects: [],
  role: {
    name: '',
    partnerName: '',
    query: ''
  },
  room: {
    current: {
      partner: '',
      project: ''
    },
    old: {
      partner: '',
      project: ''
    }
  },
  rooms: [],
  user: {
    idToken: '',
    name: '',
    picture: '',
    sub: '',
    effectiveSub: ''
  },
  isLoading: true,
  isLoadingMain: true,
  isAuthenticated: false,
  isLogined: false,
  isReadOnlyMode: false
};

const store = new Vuex.Store({
  state: defaultState,
  getters: {
    effectiveSub(state) {
      return state.user.effectiveSub || state.user.sub;
    },
    currentRoom(state, getters) {
      let room = null;
      if (getters.currentRoomId) {
        for (let i = 0; i < state.rooms.length; i++) {
          if (state.rooms[i].id === getters.currentRoomId) {
            // lastDatetimeがnullの場合は、代理店権限でルームが作成されていないので何も返さないようにする
            if (state.rooms[i].lastDatetime) {
              room = state.rooms[i];
            }
            break;
          }
        }
      }
      return room;
    },
    isCurrentRoomSynced(state, getters) {
      // Firestoreの読み込み中は、まだ作成されていないルームと区別できないので待つ
      for (let i = 0; i < state.rooms.length; i++) {
        if (state.rooms[i].id === getters.currentRoomId) {
          return state.rooms[i].isSynced;
        }
      }
      return true;
    },
    currentRoomId(state, getters) {
      return utils.getRoomId({
        partnerId: state.room.current.partner,
        projectId: state.room.current.project,
        roleName: state.role.name,
        userId: getters.effectiveSub
      });
    },
    oldRoom(state, getters) {
      let room = null;
      if (getters.oldRoomId) {
        for (let i = 0; i < state.rooms.length; i++) {
          if (state.rooms[i].id === getters.oldRoomId) {
            // lastDatetimeがnullの場合は、代理店権限でルームが作成されていないので何も返さないようにする
            if (state.rooms[i].lastDatetime) {
              room = state.rooms[i];
            }
            break;
          }
        }
      }
      return room;
    },
    oldRoomId(state, getters) {
      return utils.getRoomId({
        partnerId: state.room.old.partner,
        projectId: state.room.old.project,
        roleName: state.role.name,
        userId: getters.effectiveSub
      });
    }
  },
  mutations: {
    setProjects(state, payload) {
      state.projects = payload;
    },
    setRole(state, payload) {
      Object.assign(state.role, payload);
    },
    setRoom(state, payload) {
      for (let i = 0; i < state.rooms.length; i++) {
        const room = state.rooms[i];
        if (room.id === payload.id) {
          Object.assign(state.rooms[i], payload);
          break;
        }
      }
    },
    setRoomQuery(state, payload) {
      state.room = payload;
    },
    setRooms(state, payload) {
      state.rooms = payload;
    },
    setUser(state, payload) {
      Object.assign(state.user, payload);
    },
    setLoading(state, payload) {
      state.isLoading = payload;
    },
    setLoadingMain(state, payload) {
      state.isLoadingMain = payload;
    },
    setAuthenticated(state, payload) {
      state.isAuthenticated = payload;
    },
    setLogined(state, payload) {
      state.isLogined = payload;
    },
    setReadOnlyMode(state, payload) {
      state.isReadOnlyMode = payload;
    }
  },
  actions: {
    setProjects({ commit }, response) {
      commit('setProjects', response);
    },
    setRole({ commit }, response) {
      commit('setRole', response);
    },
    setRoom({ commit }, response) {
      commit('setRoom', response);
    },
    setRoomQuery({ commit }, response) {
      commit('setRoomQuery', response);
    },
    setRooms({ commit }, response) {
      commit('setRooms', response);
    },
    setUser({ commit }, response) {
      commit('setUser', response);
    },
    setLoading({ commit }, response) {
      commit('setLoading', response);
    },
    setLoadingMain({ commit }, response) {
      commit('setLoadingMain', response);
    },
    setAuthenticated({ commit }, response) {
      commit('setAuthenticated', response);
    },
    setLogined({ commit }, response) {
      commit('setLogined', response);
    },
    setReadOnlyMode({ commit }, response) {
      commit('setReadOnlyMode', response);
    }
  }
});

export default store;
